import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { SafeHtml, DomSanitizer } from '@angular/platform-browser';
import { Environment } from 'src/app/classes/environment';
import { CustomerService } from 'src/app/services/customer.service';


@Component({
	selector: 'contact',
	templateUrl: './contact.component.html',
	styleUrls: [ './single-page.css' ],
})
export class ContactComponent {


	bLoading = true;
	bError = false;
	legalHtml: SafeHtml = "";
	

	constructor(
		private customerService: CustomerService,
		private domSanitizer: DomSanitizer
	) {}

	
	ngOnInit(): void {
		
		this.customerService.loadLegalInformation().subscribe( data => {

			this.bLoading = false;
			this.bError = !data;
			if( data ) {
				this.legalHtml = this.domSanitizer.bypassSecurityTrustHtml( data.contact );	
			}

		} );

	}

}
